import { render, staticRenderFns } from "./problem-close.vue?vue&type=template&id=a317465c&scoped=true"
import script from "./problem-close.vue?vue&type=script&lang=js"
export * from "./problem-close.vue?vue&type=script&lang=js"
import style0 from "./problem-close.vue?vue&type=style&index=0&id=a317465c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a317465c",
  null
  
)

export default component.exports